import React from "react"
import { Navigate } from "react-router-dom"
import { useUserDetail } from "context/userDetailContext"
import { isAdminUser } from "util/isAdminUser"

type AdminRouteProps = {
    children: React.ReactElement
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
    const { userDetail } = useUserDetail()
    if (!userDetail) return null
    if (!isAdminUser(userDetail)) {
        return <Navigate to="/quotation" replace />
    }
    return children
}

export default AdminRoute
